import React from "react";
import StoresContext from "../../context/storesContext";

const WithStores = Component => {
  return class extends React.Component {
    render() {
      return (
        <StoresContext.Consumer>
          {({ stores }) => {
            const combinedStores = stores.energy
              .concat(stores.lighting)
              .sort((a, b) => (a.name > b.name ? 1 : -1));

            const distinctStores = combinedStores
              .map(store => store.storeId)
              .map(
                (store, index, list) => list.indexOf(store) === index && index
              )
              .filter(store => combinedStores[store])
              .map(store => {
                return {
                  storeId: combinedStores[store].storeId,
                  name: combinedStores[store].name
                };
              });

            return <Component stores={distinctStores} {...this.props} />;
          }}
        </StoresContext.Consumer>
      );
    }
  };
};

export default WithStores;
